import { HakimoSpinner, Modal } from '@hakimo-ui/shared/ui-base';
import { useEffect, useState } from 'react';
import { LOADING_STEPS, LOADING_STEP_DURATION } from './util';

interface Props {
  open: boolean;
}

export function TenantCreationLoadingModal(props: Props) {
  const { open } = props;
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  useEffect(() => {
    if (!open) {
      setCurrentStepIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setCurrentStepIndex((prev) => {
        if (prev < LOADING_STEPS.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    }, LOADING_STEP_DURATION);

    return () => clearInterval(interval);
  }, [open]);

  const currentText = LOADING_STEPS[currentStepIndex];

  return (
    <Modal
      open={open}
      onClose={() => null}
      closable={false}
      disableBackdropClose={true}
    >
      <div className="w-96 p-8">
        <div className="flex flex-col items-center gap-6">
          <HakimoSpinner className="h-12 w-12" />
          <div className="text-center">
            <h2 className="text-onlight-text-1 dark:text-ondark-text-1 mb-4 text-lg font-semibold">
              Creating Tenant
            </h2>
            <p className="text-onlight-text-1 dark:text-ondark-text-1 min-h-[24px] text-sm font-medium">
              {currentText}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TenantCreationLoadingModal;
